import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9836e8fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9836e8fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9836e8fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\宠物升级\\mer_mer_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9836e8fa')) {
      api.createRecord('9836e8fa', component.options)
    } else {
      api.reload('9836e8fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9836e8fa&scoped=true", function () {
      api.rerender('9836e8fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/activityProduct/index.vue"
export default component.exports